import { PoDisclaimer } from "@po-ui/ng-components";
import { PoPageDynamicSearchComponent, PoPageDynamicSearchFilters } from "@po-ui/ng-templates";

/** Valores de um filtro a partir dos disclaimers do po-page-dynamic-search (multi vem como array). */
export function disclaimerValues(disclaimers: Array<PoDisclaimer>, property: string): Array<string> {
  return disclaimers
    .filter((d) => d.property === property)
    .flatMap((d) => (Array.isArray(d.value) ? d.value : [d.value]))
    .filter((v) => v !== undefined && v !== null && v !== "")
    .map(String);
}

export function disclaimerValue(disclaimers: Array<PoDisclaimer>, property: string): any {
  return disclaimers.find((d) => d.property === property)?.value;
}

/** Valor de um filtro vindo do (p-advanced-search): multi pode vir como array ou valor único. */
export function asList(value: unknown): Array<string> {
  if (value === undefined || value === null || value === "") return [];
  return (Array.isArray(value) ? value : [value]).map(String);
}

/**
 * Mostra como disclaimers do PO filtros aplicados por código (atalhos de URL, opções recarregadas).
 * O onAdvancedSearch do PO troca todos os disclaimers, então a busca rápida em vigor é recolocada
 * (onAction com quickSearchValue não emite p-quick-search). Quem chama ignora o (p-advanced-search)
 * que isso dispara.
 */
export function showFilterDisclaimers(
  search: PoPageDynamicSearchComponent,
  fields: Array<PoPageDynamicSearchFilters>,
  filter: Record<string, unknown>,
  q: string,
): void {
  // O binding [p-filters] só atualiza no próximo ciclo; o PO precisa dos campos para montar o disclaimer.
  search.filters = fields;
  search.onAdvancedSearch({ filter });
  if (q) {
    search.onAction(q, true);
  }
}
